import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';
import { environment } from "../../environments/environment"



export interface Country {
  countryCode : string;
  countryName : string;
}

export interface State {
  stateCode : string;
  stateName : string;
  countryCode : string;
}

export interface City {
  cityName : string;
  stateCode : string;
}

@Injectable({
  providedIn: 'root'
})
export class StaticdataService {
  private subjCountry! : Subject<Country[]>
  public countryCache : Country[] = [];

  private subjState! : Subject<State[]>
  public stateCache : State[] = [];

  private subjCity! : Subject<City[]>
  public cityCache : City[] = [];

  constructor(private http : HttpClient) {
    this.subjCountry=new Subject();
    this.subjState=new Subject();
    this.subjCity=new Subject();
  }

  getCountries() : Observable<Object> {
    return this.http.get(environment.API_URL+"/api/crm/staticdata/countries",{headers : {}});
  }

  getStates() : Observable<Object> {
    return this.http.get(environment.API_URL+"/api/crm/staticdata/states",{headers : {}});
  }

  getCities() : Observable<Object> {
    return this.http.get(environment.API_URL+"/api/crm/staticdata/cities",{headers : {}});
  }

  loadCountries() {
    this.getCountries().subscribe(
    {
      next : (res) => {
        const countriesResponse =  res as any[];
        let countries : Country[]=[];
        countriesResponse.forEach(country => {
          countries.push({countryCode : country.countryCode,countryName : country.countryName});
        });
        this.countryCache =countries;
        this.subjCountry.next(countries);
    }, error : (err) => {
      console.error("Failed to get countries - " + err.error);
    }})
  }

  loadStates() {
    this.getStates().subscribe(
    {
      next : (res) => {
        const statesResponse =  res as any[];
        let states : State[]=[];
        statesResponse.forEach(state => {
          states.push({stateCode : state.stateCode,stateName : state.stateName,countryCode : state.countryCode});
        });
        this.stateCache =states;
        this.subjState.next(states);
    }, error : (err) => {
      console.error("Failed to get states - " + err.error);
    }})
  }

  loadCities() {
    this.getCities().subscribe(
    {
      next : (res) => {
        const citiesResponse =  res as any[];
        let cities : City[]=[];
        citiesResponse.forEach(city => {
          cities.push({cityName : city.cityName,stateCode : city.stateCode});
        });
        this.cityCache =cities;
        this.subjCity.next(cities);
    }, error : (err) => {
      console.error("Failed to get cities - " + err.error);
    }})
  }

  getCountrySubject() {
    return this.subjCountry.asObservable();
  }

  getStateSubject() {
    return this.subjState.asObservable();
  }

  getCitySubject() {
    return this.subjCity.asObservable();
  }
}
